import { render, staticRenderFns } from "./InstructionalVideo.vue?vue&type=template&id=7f74657b&scoped=true"
import script from "./InstructionalVideo.vue?vue&type=script&lang=js"
export * from "./InstructionalVideo.vue?vue&type=script&lang=js"
import style0 from "./InstructionalVideo.vue?vue&type=style&index=0&id=7f74657b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f74657b",
  null
  
)

export default component.exports